module.exports = __webpack_public_path__ + "b89022b7eb7ab93244e5e72778670220.png";